import styled, { css } from 'styled-components';
import { Typography } from 'modules/Typography';
import { breakpoints } from 'modules/breakpoints';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const ITEM_WIDTH = 140;
const ITEM_WIDTH_MOBILE = 80;
const containerVerticalStyles = css `
  flex-direction: column;
`;
export const Container = styled.ol `
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  overflow-x: ${({ $direction }) => ($direction === 'horizontal' ? 'auto' : 'visible')};
  ${({ $direction }) => $direction === 'vertical' && containerVerticalStyles};
`;
const itemContainerVerticalStyles = css `
  width: auto;
  height: ${pxToRem(75)};
  flex: 0 0 auto;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  /* prevent item from overflowing its parent */
  max-width: 100%;
`;
export const ItemContainer = styled.li `
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: ${theme.spacing.md};
  flex: 0 0 auto;
  width: ${pxToRem(ITEM_WIDTH)};

  /* needed for truncating properly */
  min-width: ${pxToRem(1)};
  ${({ $direction }) => $direction === 'vertical' && itemContainerVerticalStyles};
  ${({ $disabled }) => $disabled && 'opacity: 0.5'};
  ${({ $direction }) => $direction === 'horizontal' &&
    css `
      ${breakpoints.xs} {
        width: ${pxToRem(ITEM_WIDTH_MOBILE)};
      }
    `}
`;
const activeStyles = css `
  background-color: ${theme.semantic.surface.inverseRaised};
  border-color: ${theme.swatches.gray[900]};
  color: ${theme.semantic.foreground.inverse};
  outline: ${pxToRem(2)} solid ${theme.swatches.gray[900]};
  outline-offset: ${pxToRem(3)};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.inverse};
  }

  /* correct spacing between active step and line */
  margin-inline: ${pxToRem(5)};
`;
const completedStyles = css `
  background-color: ${theme.semantic.surface.inverseRaised};
  border-color: ${theme.swatches.gray[900]};
  color: ${theme.semantic.foreground.inverse};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.inverse};
  }
`;
const stepTitleVerticalStyles = css `
  width: ${pxToRem(24)};

  /* consistent spacing between steps and descriptions, no matter if active or not */
  margin-inline: ${pxToRem(5)};
  margin-block: 0;

  ${({ $active }) => $active &&
    css `
      /* correct spacing between active step and line */
      margin-block: ${pxToRem(5)};
    `};
`;
export const StepTitle = styled(Typography) `
  flex: 0 0 ${pxToRem(24)};
  height: ${pxToRem(24)};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: ${theme.borderRadius.circle};
  border: ${pxToRem(1)} solid ${theme.swatches.gray[400]};

  /* prevent Container from overlapping the active border, when overflow-x: auto */
  margin-block: ${pxToRem(5)};

  ${({ $completed }) => $completed && completedStyles};
  ${({ $active }) => $active && activeStyles};
  ${({ $direction }) => $direction === 'vertical' && stepTitleVerticalStyles};
`;
const titleContainerVerticalStyles = css `
  width: auto;
  height: 100%;
  flex-direction: column;

  &::before,
  &::after {
    width: ${({ $completed }) => ($completed ? pxToRem(2) : pxToRem(1))};
    height: auto;
  }

  &::before {
    width: ${({ $active }) => $active && pxToRem(2)};
  }
`;
export const TitleContainer = styled.div `
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${theme.spacing.sm};

  &::before,
  &::after {
    /* the lines between each step */
    content: '';
    flex: 1 0 auto;
    height: ${({ $completed }) => ($completed ? pxToRem(2) : pxToRem(1))};
    background-color: ${({ $completed }) => $completed ? theme.semantic.surface.inverseRaised : theme.swatches.gray[400]};
  }

  &::before {
    ${({ $active }) => $active &&
    css `
        height: ${pxToRem(2)};
        background-color: ${theme.semantic.surface.inverseRaised};
      `}
  }

  ${ItemContainer}:first-child &::before,
  ${ItemContainer}:last-child &::after {
    visibility: hidden;
  }

  ${({ $direction }) => $direction === 'vertical' && titleContainerVerticalStyles};
`;
const stepDescriptionVerticalStyles = css `
  text-align: left;
`;
export const StepDescription = styled(Typography) `
  text-align: center;
  white-space: normal;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: break-word;
  max-width: 100%;
  margin-inline: ${theme.spacing.sm};

  ${({ $direction }) => $direction === 'vertical' && stepDescriptionVerticalStyles};
  ${({ $hide }) => $hide && 'display: none'};
  ${({ $direction }) => $direction === 'horizontal' &&
    css `
      ${breakpoints.xs} {
        display: none;
      }
    `}
`;
